// Shared voice catalog for every Buddy-enabled activity.
// Toggle `enabled` here to control which voices appear throughout the app.
export const BUDDY_VOICE_CATALOG = [
  { id: 'ai_01', enabled: true, description: 'Warm, expressive, and story-like.', descriptionKey: 'photo_story_voice_ai_01_desc', legacyIds: ['fable'] },
  { id: 'ai_02', enabled: true, description: 'Lively, cheerful, and encouraging.', descriptionKey: 'photo_story_voice_ai_02_desc', legacyIds: ['coral'] },
  { id: 'ai_03', enabled: true, description: 'Bright, friendly, and energetic.', descriptionKey: 'photo_story_voice_ai_03_desc', legacyIds: ['nova'] },
  { id: 'ai_04', enabled: false, description: 'Customized Buddy voice.', descriptionKey: 'photo_story_voice_ai_04_desc', legacyIds: ['personalized'] },
  { id: 'ai_05', enabled: false, description: 'Raspy, rough, and gritty.', descriptionKey: 'photo_story_voice_ai_05_desc', legacyIds: ['crazy'] },
  { id: 'ai_06', enabled: false, description: 'Bright, bubbly, and sweet.', descriptionKey: 'photo_story_voice_ai_06_desc', legacyIds: ['cherry'] },
];

export const DEFAULT_BUDDY_VOICE_ID = 'ai_01';

export const getEnabledBuddyVoices = () => BUDDY_VOICE_CATALOG.filter((voice) => voice.enabled);

export const normalizeBuddyVoiceId = (value) => {
  const candidate = String(value || '').trim().toLowerCase();
  const matched = BUDDY_VOICE_CATALOG.find(
    (voice) => voice.id === candidate || voice.legacyIds?.includes(candidate),
  );
  return matched?.enabled ? matched.id : DEFAULT_BUDDY_VOICE_ID;
};
